<template>
  <div class="market" :class="{'active':marketItemList.length > 0}">
    <div class="market--header">
      <div class="market--header--title">
        <div class="title--back iconfont" @click="$router.push('/')"><span>&#xe600;</span></div>
        <div class="title--text">历史营销目录</div>
        <div class="title--add iconfont"></div>
      </div>
      <div class="market--search--layer">
        <div class="search--header">
          <input type="text" placeholder="请输入客户名称" class="search--header--ipt" v-model="cusName">
          <div class="search--header--icon iconfont" @click="handleToHisMarketSearchCusname">&#xe605;</div>
        </div>
      </div>
    </div>
    <div class="header-line"></div>
    <div class="market--content" v-if="marketItemList.length > 0">
      <div
        class="market--content--item"
        v-for="item in marketItemList"
        :key="item.id"
        @click="handleToHisMarketDetail(item.id)"
      >
        <div class="item--title">{{item.cusName}}</div>
        <div class="item--info">
          <div class="item--text">
            <div class="item-desc">最新阶段:<span>{{item.matterPhaseName}}</span></div>
            <div class="item-desc">跟进时间:<span>{{ (item.recordDate !== '0')?item.recordDate:'暂无跟进时间'}}</span></div>
            <div class="item-desc">跟进人:<span class="desc__span">{{item.actornames}}</span></div>
            <div class="item-desc">创建时间:<span>{{item.inputDate}}</span></div>
          </div>
          <div class="item--icon">
            <div class="item--icon--desc iconfont" @click.stop="handleToDisplayHisMarketTel(item.mmContactsList)">
              &#xe7b5;
              <!--            <a href="tel:64377718">&#xe813;</a>-->
            </div>
            <div class="item--icon--desc iconfont" v-if="false">&#xe622;</div>
          </div>
        </div>
      </div>
    </div>
    <div class="market--content" v-else>
      <van-empty description="暂无数据" />
    </div>
    <div class="market--search--layer" v-if="searchMarketFlag">
      <div class="search--header">
        <input type="text" placeholder="请输入客户名称" class="search--header--ipt" v-model="cusName">
        <div class="search--header--icon iconfont" @click="handleToHisMarketSearchCusname">&#xe605;</div>
        <div class="search--header--cancel" @click="handleToHisMarketCancelSearch">取消</div>
      </div>
    </div>
    <div class="market--filter--layer" v-if="filterMarketFlag">
      <div class="filter--stage">
        <div class="filter--stage--title">跟进阶段</div>
        <div class="filter--stage--item">
          <div class="item">首次营销跟进</div>
          <div class="item">跟进中</div>
          <div class="item">审判中</div>
          <div class="item">授信通过</div>
          <div class="item">授信未通过</div>
          <div class="item">暂无合作</div>
          <div class="item">自动终结</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">跟新时间</div>
        <div class="filter--stage--item">
          <div class="item">7天内更新</div>
          <div class="item">14天内更新</div>
          <div class="item">30天内更新</div>
          <div class="item">7天未更新</div>
          <div class="item">14天未更新</div>
          <div class="item">30天未更新</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">客户来源</div>
        <div class="filter--stage--item">
          <div class="item">自主营销</div>
          <div class="item">领导推荐</div>
          <div class="item">银行推荐</div>
          <div class="item">中介推荐</div>
          <div class="item">老客户推荐</div>
          <div class="item">其他</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">所属行业</div>
        <div class="filter--stage--item">
          <div class="item">战新行业</div>
          <div class="item">其他</div>
        </div>
      </div>
      <div class="filter--btn">
        <div class="filter--btn--clear">
          清空条件
        </div>
        <div class="filter--btn--clear">
          确认
        </div>
      </div>
    </div>
    <div class="market--create--layer" v-if="false">
      <div class="create--content">
        <div class="create--item">
          <div class="item">
            <div class="create--text active">最新更新</div>
            <div class="create--text iconfont active">&#xe621;</div>
          </div>
          <div class="item">
            <div class="create--text">最新创建</div>
            <div class="create--text iconfont">&#xe621;</div>
          </div>
        </div>
        <div class="create--close iconfont">&#xe606;</div>
      </div>
    </div>
    <van-popup
      v-model="vanMarketShow"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div
        class="market--tel"
        v-for="contractItem in mmContactsList"
        :key="contractItem.id"
        @click="handleToHisMarketCallTel(contractItem.contactPhone)"
      >
        <div class="market--tel--name">{{contractItem.contactName}}</div>
        <div class="market--tel--num">{{contractItem.contactPhone}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  name: 'Market',
  data () {
    return {
      vanMarketShow: false, // 控制电话显示
      searchMarketFlag: false, // 控制搜索页面显示
      filterMarketFlag: false, // 控制筛选页面显示
      pageNum: 1, // 获取营销事项列表从那一条开始
      pageSize: 10, // 获取营销事项列表一共多少条
      cusName: '', // 搜索指定客户
      matterName: '', // 筛选
      mmContactsList: [], // 联系人信息
      marketItemList: [], // 营销信息列表
      marketItemTotal: '', // 营销信息列表总数
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollMarketFlag: true // 控制滑动pageNum在没有返回值的时候不能加1
    }
  },
  beforeMount () {
    this.getHisMarketList()
  },
  mounted () {
    // const marketContentElement = document.body
    window.addEventListener('scroll', this.handleToHisMarketListScroll, true)
  },
  destroyed () {
    // const marketContentElement = document.body
    window.removeEventListener('scroll', this.handleToHisMarketListScroll, true)
  },
  methods: {
    // 获取营销事项列表
    async getHisMarketList () {
      const result = await get('/api/CBMS-APP/mmMarketMatter/hislist', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cusName: this.cusName,
        matterName: this.matterName
      })
      if (result.success) {
        this.marketItemList = result.data.records
        this.marketItemTotal = result.data.total
      } else {
        this.$toast.success('获取数据出错')
      }
    },
    // 弹出拨打电话页面
    handleToDisplayHisMarketTel (itemList) {
      this.vanMarketShow = true
      this.mmContactsList = itemList
    },
    // 打电话
    handleToHisMarketCallTel (contactPhone) {
      window.location.href = `tel://${contactPhone}`
    },
    // 滑动到底部触发事件加载更多数据
    async handleToHisMarketListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        if (this.marketItemList.length < this.marketItemTotal && this.scrollMarketFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollMarketFlag = false
          const result = await get('/api/CBMS-APP/mmMarketMatter/hislist', {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            cusName: this.cusName,
            matterName: this.matterName
          })
          if (result.success) {
            this.scrollMarketFlag = true
            this.marketItemList = this.marketItemList.concat(result.data.records)
          }
        } else if (this.marketItemList.length === this.marketItemTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    },
    // 跳转到客户详情
    handleToHisMarketDetail (id) {
      this.$router.push({ name: 'ViewMarket', params: { id, routerName: 'hismarket', routeTag: 'hismarket' } })
    },
    // 条件过滤
    handleToHisMarketFiler (filterVal) {
      if (filterVal === 'cusName') {
        document.body.style.overflow = 'hidden'
        this.searchMarketFlag = true
      } else {
        this.$toast.success('功能暂未上线')
      }
    },
    // 根据客户名称搜索
    handleToHisMarketSearchCusname () {
      // document.body.style.overflow = 'auto'
      // this.searchMarketFlag = false
      this.marketItemList = []
      this.marketItemTotal = ''
      this.getHisMarketList()
    },
    // 取消根据客户名称搜索
    handleToHisMarketCancelSearch () {
      document.body.style.overflow = 'auto'
      this.searchMarketFlag = false
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.market
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .market--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .market--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      padding : 0 16px
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        flex : 1
        text-align : left
        span
          font-size : 42px
          padding : 0 16px
      .title--text
        flex : 1
        text-align : center
      .title--add
        flex : 1
        text-align : right
        span
          font-size : 42px
          padding : 0 16px
    .market--header--filter
      box-sizing : border-box
      width : 100%
      display : flex
      background : #f7f7f7
      padding : 28.5px 16px
      .filter--search
        flex:1
        text-align : center
        vertical-align : top
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        span
          padding-right : 16px
      .filter--text
        flex : 1
        text-align : center
        vertical-align : top
        border-left : 1px solid #7d7878
        border-right : 1px solid #7d7878
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        span
          padding-right : 16px
      .filter--add
        flex : 1
        text-align : center
        vertical-align : top
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        span
          padding-right : 16px
    .market--search--layer
      .search--header
        padding : 16px 16px 0 16px
        display : flex
        background-color : #faf9f9
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
        .search--header--ipt
          padding : 16px 0 16px 16px
          flex : 1
          height : 34px
          outline: none
          -webkit-appearance: none
          border-radius:0
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-top-left-radius : 12px
          border-bottom-left-radius : 12px
        .search--header--icon
          width : 100px
          height : 34px
          background-color : #faf9f9
          text-align : center
          padding : 16px 16px 16px 16px
          font-size: 34px
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-top-right-radius : 12px
          border-bottom-right-radius : 12px
  .header-line
    height : 170px
    width : 100%
  .market--content
    .market--content--item
      margin : 16px 16px 0 16px
      border : 2px solid #f7f7f7
      border-radius : 12px
      .item--title
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
      .item--info
        display : flex
        .item--text
          flex : 1
          .item-desc
            padding : 8px 0 8px 32px
            font-family: MyriadPro-Regular
            font-size: 28px
            font-weight: normal
            font-stretch: normal
            color: #333333
            span
              padding-left : 24px
              &.desc__span
                padding-left : 50px
        .item--icon
          width : 150px
          display : flex
          flex-direction : column
          align-items : center
          .item--icon--desc
            transform : translateY(25%)
            flex : 1
            font-size : 38px
            font-family: MyriadPro-Regular
            font-weight: normal
            font-stretch: normal
            color : #4282e1
            a
              text-decoration : none
              color : #4282e1
  .market--tel
    display : flex
    align-items : center
    margin-top : 32px
    font-family: MyriadPro-Regular
    font-size: 28px
    font-weight: normal
    font-stretch: normal
    color : #4282e1
    &:nth-child(1)
      margin-top : 80px
    .market--tel--name
      flex : 1
      padding : 16px 0
      text-align : center
    .market--tel--num
      flex : 1
      padding : 16px 0
      text-align : left
  .market--filter--layer
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .filter--stage
      margin-top : 16px
      padding-bottom : 16px
      border-bottom : 1px solid #8b8787
      .filter--stage--title
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
      .filter--stage--item
        margin : 0 16px
        display : flex
        flex-wrap : wrap
        font-size: 28px
        .item
          width : calc((100% - 96px)/4)
          margin-left : 8px
          margin-top : 8px
          padding : 16px 8px
          height : 66px
          text-align : left
          background-color : #ffffff
    .filter--btn
      margin-top : 64px
      display : flex
      .filter--btn--clear
        margin : 0 10%
        padding : 24px 16px
        flex : 1
        text-align : center
        background-color : #4282e1
        color : #ffffff
        border-radius : 12px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
  .market--create--layer
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : rgba(0,0,0,0.5)
    z-index : 11
    overflow-y : hidden
    .create--content
      position : absolute
      left :0
      bottom : 0
      width : 100vw
      height : 40vh
      background-color : #ffffff
      border-top-right-radius : 16px
      border-top-left-radius : 16px
      .create--item
        position : absolute
        top: 50%
        left:50%
        transform : translate(-50%,-50%)
        width : 100%
        .item
          display : flex
          padding : 24px 0
          margin : 0 36px
          justify-content : space-between
          border-bottom : 1px solid #b6b5b5
          .create--text
            font-family: MyriadPro-Regular
            font-size: 32px
            font-weight: normal
            font-stretch: normal
            color : #333333
            &.active
              color : #4282e1
      .create--close
        position : absolute
        right : 12px
        top: 12px
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color : #333333
</style>
